import classes from './ContentWrapper.module.scss'

export default function ContentWrapper({ children }) {
  return (
    <div className={classes['content-wrapper']} >
      {children}
    </div>
  )
}